@if(IsVisible)
{
<div class="card AuftragsCard">
  @if(HeaderText != "")
  {
  <h3>{{ HeaderText }}</h3>
  }
  <div class="card-body">
    @if(Item != null)
    {
    <ng-content></ng-content>
    }
  </div>
</div>
}

